import BasePainterTool from './BasePainterTool';
import TOOL_NAMES from './constants/toolNames';

export default class DeleteTool extends BasePainterTool {
  constructor(props = {}) {
    const defaultProps = { name: TOOL_NAMES.DELETE_TOOL };
    const initialProps = Object.assign(defaultProps, props);
    super(initialProps, 'delete');
  }
}
